/**
 * Setting Object used by other services and components
 */
export class DotSettings {
    site: string;
    jwt: string;
}